export const loadMaterialSymbols = (materialSymbols = []) => {
  if (typeof window === 'undefined' || typeof document === 'undefined')
    return null;

  const linkId = 'material-symbols-global';
  let link = document.getElementById(linkId);
  const allSymbols = materialSymbols.join('');

  if (link) {
    link.href = `https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined&text=${encodeURIComponent(
      allSymbols
    )}`;
  } else {
    link = document.createElement('link');
    link.rel = 'stylesheet';
    link.id = linkId;
    link.href = `https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined&text=${encodeURIComponent(
      allSymbols
    )}`;
    document.head.appendChild(link);
  }

  return new Promise((resolve, reject) => {
    link.onload = resolve;
    link.onerror = reject;
  });
};
